import React from 'react';
import { Link, withRouter } from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.css';
import '../../assets/css/style.css';

// import Checkpoint from '../../assets/img/icons/checkpoint_orange.png';
// import Display from '../../assets/img/icons/display_orange.png';
// import Monitor from '../../assets/img/icons/monitor_orange.png';
// import Logs from '../../assets/img/icons/logs_orange.png';
// import Users from '../../assets/img/icons/users_orange.png';
// import Report from '../../assets/img/icons/report_orange.png';
// import CustomContent from '../../assets/img/icons/custom_content_orange.png';

import Checkpoint from '../../assets/img/icons/checkpoint.png';
import Display from '../../assets/img/icons/display.png';
// import DeviceGroups from '../../assets/img/icons/device_groups_green.png';
import Monitor from '../../assets/img/icons/monitor.png';
import Logs from '../../assets/img/icons/logs.png';
import Users from '../../assets/img/icons/users.png';
import Report from '../../assets/img/icons/report.png';
import CustomContent from '../../assets/img/icons/custom_content.png';

import CheckpointWhite from '../../assets/img/icons/checkpoint_white.png';
import DisplayWhite from '../../assets/img/icons/display_white.png';
// import DeviceGroupsWhite from '../../assets/img/icons/device_groups_white.png';
import MonitorWhite from '../../assets/img/icons/monitor_white.png';
import LogsWhite from '../../assets/img/icons/logs_white.png';
import UsersWhite from '../../assets/img/icons/users_white.png';
import ReportWhite from '../../assets/img/icons/report_white.png';
import CustomContentWhite from '../../assets/img/icons/custom_content_white.png';

import UserDeviceActionsWhite from '../../assets/img/icons/device_actions_white.png';
import UserDeviceActionsGreen from '../../assets/img/icons/device_actions_green.png';

import * as utils from '../../utils';

class Navbar extends React.Component {
  constructor(props) {
    super(props);

    let navItems = [
      {
        name: 'Монитор',
        link: '/monitor',
        icon: {
          default: Monitor,
          active: MonitorWhite,
        },
      },
      {
        name: 'Табло',
        link: '/displays',
        icon: {
          default: Display,
          active: DisplayWhite,
        },
      },
      // {
      //     name: "Группы табло",
      //     link: "/display-groups",
      //     icon: {
      //         default: DeviceGroups,
      //         active: DeviceGroupsWhite
      //     }
      // },
      {
        name: 'Остановочные пункты',
        link: '/checkpoints',
        icon: {
          default: Checkpoint,
          active: CheckpointWhite,
        },
      },
      {
        name: 'События',
        link: '/logs',
        icon: {
          default: Logs,
          active: LogsWhite,
        },
      },
      {
        name: 'Пользователи',
        link: '/users',
        icon: {
          default: Users,
          active: UsersWhite,
        },
      },
      {
        name: 'Операции с устройствами',
        link: '/device-actions',
        icon: {
          default: UserDeviceActionsGreen,
          active: UserDeviceActionsWhite,
        },
      },
      {
        name: 'Отчёты',
        link: '/reports',
        icon: {
          default: Report,
          active: ReportWhite,
        },
      },
      {
        name: 'Пользовательский контент',
        link: '/custom-content',
        icon: {
          default: CustomContent,
          active: CustomContentWhite,
        },
      },
    ];

    this.state = {
      navItems: navItems,
    };
  }

  render() {
    let viewport = utils.getViewport();
    let Content;

    if (viewport === 'xs' || viewport === 'sm') {
      Content = withRouter((props) => {
        let navItems = [];
        let selectedNavItem;

        this.state.navItems.forEach((item, i) => {
          if (props.location.pathname.indexOf(item.link) === -1) {
            navItems.push(
              <Link
                key={i + 1}
                to={item.link}
                className="dropdown-item nav-link primary-nav-item"
              >
                <img className="mr-2" src={item.icon.default} alt="" />
                <span>{item.name}</span>
              </Link>,
            );
          } else {
            selectedNavItem = (
              <Link
                key={i + 1}
                to={item.link}
                className="dropdown-toggle nav-link primary-nav-item primary-nav-item-active"
                data-toggle="dropdown"
              >
                <img className="mr-2" src={item.icon.active} alt="" />
                <span>{item.name}</span>
              </Link>
            );
          }
        });

        return (
          <div className="dropdown primary-nav text-center">
            {selectedNavItem || (
              <Link
                to={this.state.navItems[0].link}
                className="dropdown-toggle nav-link primary-nav-item primary-nav-item-active"
                data-toggle="dropdown"
              >
                <img
                  className="mr-2"
                  src={this.state.navItems[0].icon.active}
                  alt=""
                />
                <span>{this.state.navItems[0].name}</span>
              </Link>
            )}
            <div className="dropdown-menu">
              <nav className="nav flex-column">{navItems}</nav>
            </div>
          </div>
        );
      });
    } else {
      Content = withRouter((props) => (
        <nav className="nav flex-column primary-nav">
          <div className="primary-nav-container">
            {this.state.navItems.map((item, i) => {
              let isActive = props.location.pathname.indexOf(item.link) !== -1;
              return (
                <Link
                  key={i + 1}
                  to={item.link}
                  className={
                    isActive
                      ? 'nav-link primary-nav-item primary-nav-item-active'
                      : 'nav-link primary-nav-item'
                  }
                >
                  <img
                    className="mr-2"
                    src={isActive ? item.icon.active : item.icon.default}
                    alt=""
                  />
                  <span>{item.name}</span>
                </Link>
              );
            })}
          </div>
        </nav>
      ));
    }

    return <Content />;
  }
}

export default Navbar;
